export default {
  QUICK_NUMBERS: '/carrier/stats?quick_numbers',
  EVENTS: (year) => `/carrier/calendar?arriveEarlyDateYear=${year}&read`
}
